<template lang="pug">
  .gl-reset-password
    // nav
    gl-nav

    // page wrapper
    .gl-layout--medium-width

      // loading: config
      gl-loading-card(:options="{ message: 'Loading application', location: 'page' }" v-if="!config")

      // form
      b-form.gl-card.gl-card--form(@submit.prevent="submitForm" v-if="config" novalidate)
        .gl-card--form__header
          .gl-card--form__header__title Update Password

        // body
        .gl-card--form__body
          gl-alert(
            :options="{ errorList, infoList, includesHtml: true }"
            @clear-error-list="errorList = []"
            @clear-info-list="infoList = []")
          b-form-group(:state="form.currentPassword.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Current Password" label-for="currentPassword")
            b-form-input(
              :state="form.currentPassword.state"
              v-model.trim="form.currentPassword.val"
              v-gl-focus="true"
              required
              type="password")
            .invalid-feedback(v-if="form.currentPassword.invalidFeedback") {{ form.currentPassword.invalidFeedback }}
          b-form-group(:state="form.newPassword.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="New Password" label-for="newPassword")
            b-form-input(
              :state="form.newPassword.state"
              v-model.trim="form.newPassword.val"
              required
              type="password")
            .invalid-feedback(v-if="form.newPassword.invalidFeedback") {{ form.newPassword.invalidFeedback }}
          b-form-group(:state="form.confirmedPassword.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Confirm New Password" label-for="confirmedPassword")
            b-form-input(
              :state="form.confirmedPassword.state"
              v-model.trim="form.confirmedPassword.val"
              required
              type="password")
            .invalid-feedback(v-if="form.confirmedPassword.invalidFeedback") {{ form.confirmedPassword.invalidFeedback }}

        // footer
        .gl-card--form__footer
          gl-btn(:options="{ label: 'Save New Password', size: 'full-width', type: 'submit', style: 'brand', isLoading: isLoading.submitForm }")

</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // data
  data () {
    return {
      infoList: [],
      errorList: [],
      form: {
        currentPassword: { val: '', state: null, invalidFeedback: '' },
        newPassword: { val: '', state: null, invalidFeedback: '' },
        confirmedPassword: { val: '', state: null, invalidFeedback: '' }
      },
      isLoading: {
        submitForm: false
      }
    }
  },

  // methods
  methods: {
    submitForm () {
      // clear previous errors / messages
      this.infoList = []
      this.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.form)

      // if form is valid
      if (this.validateForm()) {
        // start loading
        this.isLoading.submitForm = true

        // updatePassword
        return this.$glHttp.post('user/update-password', this.$glForm.getVals(this.form))
          .then(() => {
            // push info message
            this.infoList.push('Password updated successfully')
          })
          .catch(e => {
            // push errors
            this.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.isLoading.submitForm = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError(this.$el)
      }
    },
    validateForm () {
      // if no currentPassword -> invalid
      if (!this.form.currentPassword.val) {
        this.form.currentPassword.state = 'invalid'
        this.form.currentPassword.invalidFeedback = 'A current password is required'
      }
      // if no newPassword -> invalid
      if (!this.form.newPassword.val) {
        this.form.newPassword.state = 'invalid'
        this.form.newPassword.invalidFeedback = 'A new password is required'
      }
      // if no confirmedPassword -> invalid
      if (!this.form.confirmedPassword.val) {
        this.form.confirmedPassword.state = 'invalid'
        this.form.confirmedPassword.invalidFeedback = 'A confirmed password is required'
      }
      // if passwords are supplied but do not match -> push errors
      if (this.form.newPassword.val && this.form.confirmedPassword.val && this.form.newPassword.val !== this.form.confirmedPassword.val) {
        this.errorList.push('New Password and Confirm Password are not the same')
      }

      // returns true if no fields are invalid && the errorList is empty
      return (this.$glForm.hasNoInvalid(this.form) && this.errorList.length === 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UpdatePassword.vue